/* eslint-disable @typescript-eslint/no-explicit-any */
import L from "leaflet";

interface CircleData {
  center: { lat: number; lng: number };
  radius: number;
}

interface CircleGroupOptions {
  stroke?: string;
  color?: string;
  fillOpacity?: number;
  opacity?: number;
  [key: string]: unknown;
}

// Extend Leaflet types
declare module "leaflet" {
  interface CircleGroup extends Path {
    getCircles(): CircleData[];
    setCircles(circles: CircleData[]): this;
  }
  let CircleGroup: any;
}

L.CircleGroup = (L as any).Path.extend({
  options: {
    fill: "#0000FF",
    fillRule: "nonzero",
  },

  initialize: function (circles: CircleData[], options?: CircleGroupOptions): void {
    L.setOptions(this, options);
    this.setCircles(circles);
  },

  getCircles: function (): CircleData[] {
    return this._circles;
  },

  setCircles: function (circles: CircleData[]): L.CircleGroup {
    this._circles = circles;
    return this.redraw();
  },

  _project: function (): void {
    this._projectCircles(this._circles);
  },

  _projectCircles: function (circles: CircleData[]): void {
    this._projected = [];
    for (let i = 0; i < circles.length; i++) {
      this._projected.push({
        center: this._map.latLngToLayerPoint(L.latLng(circles[i].center.lat, circles[i].center.lng)),
        radius: this._projectRadius(L.latLng(circles[i].center.lat, circles[i].center.lng), circles[i].radius),
      });
    }
  },

  _projectRadius: function (center: L.LatLng, radiusInMeter: number): number {
    const metresPerPixel =
      (40075016.686 * Math.abs(Math.cos((center.lat * Math.PI) / 180))) /
      Math.pow(2, this._map.getZoom() + 8);
    return radiusInMeter / metresPerPixel;
  },

  _update: function (): void {
    if (!this._map) {
      return;
    }
    this._updatePath();
  },

  _updatePath: function (): void {
    let path = "";
    for (let i = 0, len = this._projected.length; i < len; i++) {
      const circle = this._projected[i];
      path +=
        "M " +
        circle.center.x +
        " " +
        circle.center.y +
        " m -" +
        circle.radius +
        ", 0 a " +
        circle.radius +
        "," +
        circle.radius +
        " 0 1,1 " +
        2 * circle.radius +
        ",0 a " +
        circle.radius +
        "," +
        circle.radius +
        " 0 1,1 -" +
        2 * circle.radius +
        ",0 z ";
    }

    (this._renderer as any)._setPath(this, path);
  },
});

export const CircleGroup = function (opts: CircleData[], options?: CircleGroupOptions): L.CircleGroup {
  return new L.CircleGroup(opts, options);
};

export const circleGroupExtends = L.CircleGroup;